import * as React from 'react';
import { Subtract } from 'utility-types';
import { ServiceLocator } from '../../app/ServiceLocator';

import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { IScheduleFrequencyDescriptionFilter } from '../../ts/filters/ScheduleFrequencyDescriptionFilter';
import { FlowPlace } from '../../ts/models/FlowPlace';
import { IPlace } from '../../ts/models/IPlace';
import { Telemetry } from '../../ts/services/TelemetryService';

export interface InjectedFlowSpaceServiceInjectorProps {
  readonly place: IPlace;
  readonly sanitizer: ng.sanitize.ISanitizeService;
  readonly scheduleFrequencyDescriptionFilter: IScheduleFrequencyDescriptionFilter;
  readonly telemetry: Telemetry;
  readonly translate: IReactTranslateService;
}

export interface FlowSpaceServiceInjectorProps {
  readonly flowId: string;
}

export function withFlowSpaceServiceInjector<P extends InjectedFlowSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function FlowSpaceServiceInjector(
    props: Subtract<P, InjectedFlowSpaceServiceInjectorProps> & FlowSpaceServiceInjectorProps
  ) {
    const $filter = ServiceLocator.get<ng.IFilterService>('$filter');
    const $sanitize = ServiceLocator.get<ng.sanitize.ISanitizeService>('$sanitize');
    const $translate = ServiceLocator.get<ng.translate.ITranslateService>('$translate');
    const flowPlace = ServiceLocator.get<FlowPlace>('FlowPlace');
    const telemetry = ServiceLocator.get<Telemetry>('TelemetryService');

    return <Component
      {...props as unknown as P}
      place={flowPlace.create(props.flowId)}
      sanitizer={$sanitize}
      scheduleFrequencyDescriptionFilter={$filter('scheduleFrequencyDescription')}
      telemetry={telemetry}
      translate={$translate.instant.bind($translate)}
    />;
  };
}
